<p>{{ 'CATEGORIES.PLACEHOLDER' | translate }}</p>
